export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_EU-tr-TR.0f030b69.xlsx";